<template>
  <v-card outlined :class="{ 'ml-14 mt-6': !isTopLevel }">
    <v-card-subtitle class="grey lighten-4 mb-2 pa-3">
      <span>{{ cardTitle }}</span>
    </v-card-subtitle>
    <v-expansion-panels v-if="fields && fields.length" flat accordion>
      <field-block
        v-for="(field, index) in fields"
        ref="field-block"
        :key="index"
        :duplicate-keys="duplicateKeys"
        :field="field"
        :is-loading="isLoading"
        :module-name="moduleName"
        :readonly="readonly"
        @delete="onFieldDelete(index)"
        @input="onInput($event, index)"
      />
    </v-expansion-panels>
    <div class="d-flex align-center pa-4">
      <select-list
        v-model="newFieldType"
        :items="moduleFieldTypeOptions"
        :disabled="readonly"
        class="mr-4"
        custom-type="icon"
        label="Field Select"
        clearable
        hide-details
      />
      <v-btn :disabled="!newFieldType" color="primary" depressed @click="onFieldAdd">
        <v-icon left>add</v-icon>
        <span>Add Field</span>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'
// Components
import SelectList from '@/components/forms/select-list'

const blankField = type => ({
  key: '',
  required: false,
  title: '',
  type,
  fields: [],
  dynamic: false,
  options: [],
})

export default {
  name: 'FieldBlockGroup',
  components: {
    FieldBlock: () => import('@/views/modules/components/field-block'),
    SelectList,
  },
  model: {
    prop: 'fields',
  },
  props: {
    duplicateKeys: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isTopLevel: {
      type: Boolean,
      default: false,
    },
    moduleName: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    newFieldType: null,
  }),
  computed: {
    ...mapGetters({
      getItemsForOption: 'options/getItemsForOption',
      formattedOption: 'options/formattedOption',
    }),
    cardTitle() {
      return this.isTopLevel ? 'Fields' : 'Flexible Fields'
    },
    moduleFieldTypeOptions() {
      return this.getItemsForOption('moduleFieldTypes').filter(({ value }) => this.isTopLevel || value !== 'flexible')
    },
  },
  methods: {
    onFieldAdd() {
      this.$emit('input', [...this.fields, blankField(this.newFieldType)])
      this.newFieldType = null
    },
    onFieldDelete(index) {
      this.$emit('input', this.fields.slice(0, index).concat(this.fields.slice(index + 1)))
    },
    onInput(field, index) {
      this.$emit(
        'input',
        this.fields
          .slice(0, index)
          .concat(field)
          .concat(this.fields.slice(index + 1))
      )
    },
    lockKeys() {
      this.$refs['field-block'].map(fieldBlock => fieldBlock.lockKeys())
    },
  },
}
</script>
